/**
 *
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 *
 * instead, edit one of the `.graphql` files in this project and run
 *
 * yarn run generate:graphql
 *
 * for this file to be re-created
 */

import { api } from '@app/services/graphql-api'
import * as Types from '../../app/services/auto-generated/graphql/types.generated'

export type GetUserQueryVariables = Types.Exact<{
  uid?: Types.InputMaybe<Types.Scalars['Int']>
}>

export type GetUserQuery = {
  __typename?: 'Query'
  users?: {
    __typename?: 'UserTypeConnection'
    edges: Array<{
      __typename?: 'UserTypeEdge'
      node?: { __typename?: 'UserType'; username?: string; imagePlaceholder?: string }
    }>
  }
}

export const GetUserDocument = `
    query GetUser($uid: Int) {
  users(uid: $uid) {
    edges {
      node {
        username
        imagePlaceholder
      }
    }
  }
}
    `

const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    GetUser: build.query<GetUserQuery, GetUserQueryVariables | void>({
      query: (variables) => ({ document: GetUserDocument, variables }),
    }),
  }),
})

export { injectedRtkApi as api }
export const { useGetUserQuery, useLazyGetUserQuery } = injectedRtkApi
